import type { Assignment } from '../Assignment';
import type { ReorderedRouteType } from '../AssignmentApi';
import { z } from 'zod';

export const RouteComparisionSchema = z.object({
    eta_m: z.number().nullable(),
    distance_m: z.number().nullable(),
    eta_with_stops_m: z.number().nullable(),
});
export type RouteComparisionType = z.infer<typeof RouteComparisionSchema>;

export class PlanningDeliveryRouteComparision {
    private _assignment: Assignment;

    constructor(assignment: Assignment) {
        this._assignment = assignment;
    }

    getRouteInfo() {
        return this._assignment.getRouteInfo().route;
    }

    getModifiedRouteData(): ReorderedRouteType | null {
        return this._assignment.getModifiedRouteData();
    }

    getComparisonData(): RouteComparisionType {
        let routeInfo = this.getRouteInfo();
        let modifiedRouteData = this.getModifiedRouteData();
        return {
            eta_m: modifiedRouteData ? modifiedRouteData.eta_m - routeInfo.eta_m : null,
            distance_m: modifiedRouteData
                ? modifiedRouteData.distance_m - routeInfo.distance_m
                : null,
            eta_with_stops_m: modifiedRouteData
                ? modifiedRouteData.eta_with_stops_m - routeInfo.eta_with_stops_m
                : null,
        };
    }
}
